import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Space,
  Input,
  Form,
  Radio,
  Select,
  message,
  Row,Col,
  notification,
  Checkbox,
} from "antd";
import { Table } from "antd";
import { SearchOutlined,LockOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
import { EditFilled } from "@ant-design/icons";
const key = "updatable";
const openMessageLoading = (load) => {
  message.loading({ content: load, key });
};
const openMessageSuccess = (loaded) => {
  message.success({ content: loaded, key, duration: 2 });
};

const Masterprofile = (props) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visiblePermission,setvisiblePermission] = useState(false);
  const [permissionSet,setPermissionSet] = useState([]);
  const [dataSource, setdataSource] = useState([]);
  const [size, setSize] = useState();
  const [totalRecord, settotalRecord] = useState(0);
  const [submitType, setsubmitType] = useState("insert");
  const [form] = Form.useForm();
  const [userSetting,setUserSetting] = useState({});
  const [profileId,setProfileId] = useState("");
  const logUser = window.sessionStorage.getItem("user");

  const addprofile = () => {
    setsubmitType("insert");
    fetchCount();
    showLargeDrawer();
  };
  const showLargeDrawer = () => {
    setSize("large");
    setVisible(true);
  };
  const drawerClose = () => {
    setVisible(false);
    form.resetFields();
  };
  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 10 },
  };
  const onFinish = (e) => {
    const data = e;
    data['user']  = logUser;
    openMessageLoading("Adding Profile", 20);
    let BaseURL = path + src + "insertprofile.php";
    axios
      .post(BaseURL, data)
      .then((response) => {
        openMessageSuccess(response.data, 20);
        drawerClose();
        fetchTableData();
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };

  const fetchTableData = () => {
    setLoading(true);
    let BaseURL = path + src + "profilelist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        let filteredArr = response.data.sort((a,b)=>{return b.sno - a.sno});
        setdataSource(filteredArr);
        settotalRecord(filteredArr.length);
        drawerClose();
        setLoading(false);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchCount = () => {
  
        let value = dataSource.length + 1 ; 
        let valueStr = "0000"+ value.toString();
        settotalRecord(dataSource.length);
        form.setFieldsValue({
          code: "PRF-" + (valueStr.substr(-4)),
          submit: "insert",
        });
  };
  const onEditProfile = (record) => {
    setsubmitType("update");
    console.log(submitType);
    showLargeDrawer();
    let response = dataSource.filter((list)=>{return list.code == record.code});
    console.log(response);
      form.setFieldsValue({
        code: response[0].code,
        profile: response[0].profile,
        date: response[0].date,
        time: response[0].time,
        submit: "update",
      })
  };
  const closePermission = () =>{
    setvisiblePermission(false);
    setPermissionSet([]);
  }
  const handlePermissionCheck = (record,permission) =>{
 console.log(record,permission);
 let dataValue = record[permission] == 1 ? 0 : 1 ;
 let BaseURL = path + src + "update_profile_permission.php?profile="+record.profile+"&&column="+permission+"&&filename="+record.filename+"&&value="+dataValue;
 axios
 .get(BaseURL)
   .then((response) => {
     console.log(response.data);
     fetch_profile_permission(record.profile);
     if(permission == 'show'){
      props.onShowChanged();
     }
   })
   .catch((error) => {
     openMessageSuccess(error, 10);
   });
  }
  const handlePermissionAccess = (event) =>{
    console.log(event);
    setProfileId(event.code);
    fetch_profile_permission(event.code);
  setvisiblePermission(true);
  }
  const fetch_profile_permission = (profile) =>{
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
       setPermissionSet(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  }
  const handlePermissionInsert = () =>{
    console.log();
    let permission = document.getElementById('permissionData').value;
   let data = {'permission' : permission }
   if(!data.permission){
    return;
   }
   let BaseURL = path + src + "insert_profile_permission.php";
    axios
    .post(BaseURL, data)
      .then((response) => {
        fetch_profile_permission(profileId);
        document.getElementById('permissionData').value = null;
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  }
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permissions = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'masterprofile'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  useEffect(() => {
    fetch_profile_permissions(profile);
    fetchTableData();
  }, []);
  const permissionColumn = [
    {
      key  : "1",
      title: "Sno",
      dataIndex:"sno"
    },
    {
      key  : "2",
      title: "Profile",
      dataIndex:"profile"
    },
    {
      key  : "3",
      title: "Filename",
      dataIndex:"filename"
    },
    {
      key  : "4",
      title: "Show",
      render: (record) => (
        <Checkbox checked={Number(record.show) == 1 ? true : false } onChange={(value)=>handlePermissionCheck(record,'show')}>

        </Checkbox>
      ),
    },
    {
      key  : "5",
      title: "Add",
      render: (record) => (
        <Checkbox checked={Number(record.add) == 1 ? true : false } onClick={(value)=>handlePermissionCheck(record,'add')}>

        </Checkbox>
      ),
    },
    {
      key  : "6",
      title: "Edit",
      render: (record) => (
        <Checkbox checked={Number(record.edit) == 1 ? true : false } onClick={(value)=>handlePermissionCheck(record,'edit')}>

        </Checkbox>
      ),
    },
    {
      key  : "7",
      title: "Print",
      render: (record) => (
        <Checkbox checked={Number(record.print) == 1 ? true : false } onClick={(value)=>handlePermissionCheck(record,'print')}>

        </Checkbox>
      ),
    },
    {
      key  : "8",
      title: "Excel",
      render: (record) => (
        <Checkbox checked={Number(record.excel) == 1 ? true : false } onClick={(value)=>handlePermissionCheck(record,'excel')}>

        </Checkbox>
      ),
    }
  ]
  const columns = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "sno",
      sorter: (record1, record2) => {
        return record1.id > record2.id;
      },
    },
    {
      key: "2",
      title: "Code",
      dataIndex: "code",
    },
    {
      key: "3",
      title: "Profile",
      dataIndex: "profile",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.profile.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "6",
      title: "Edit",
      render: (record) => (
       Number(userSetting.edit) ?  <Button
          title="Edit"
          size="small"
          type="primary"
          onClick={() => {
            onEditProfile(record);
          }}
        >
          <EditFilled />
        </Button> : ''
      ),
    },
    {
      key: "6",
      title: "Permission",
      render: (record) => (
       Number(userSetting.add)== 1 ?  <Button
          title="Permission"
          size="small"
          type="danger"
          onClick={() => {
            handlePermissionAccess(record);
          }}
        >
         <LockOutlined />
        </Button> : ''
      ),
    },
    // {
    //   key: "7",
    //   title: "Delete",
    //   render: (record) => (
    //     <Button
    //       title="Edit"
    //       size="small"
    //       type="danger"
    //       onClick={() => {
    //         openNotification(record);
    //       }}
    //     >
    //       Delete
    //     </Button>
    //   ),
    // },
  ];

  return (
    <>
      <Space>
        <Button type="primary" onClick={addprofile}>
          Add Profile +
        </Button>
      </Space>
      <Modal
        title={submitType == "insert" ? "Add Profile" : "Edit Profile"}
        style={{ top: 20 }}
        visible={visible}
        onOk={() => drawerClose()}
        onCancel={() => drawerClose()}
        width={"90vw"}
        maskClosable={false}
        footer={null}
      >
        <Form {...layout} form={form} name="nest-messages" onFinish={onFinish}>
          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Code"  style={{color:"red"}} disabled={true} autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="profile"
            label="ProfileMethod"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter Your Profile" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="submit"
            label="sumit"
            value={submitType}
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="date"
            label="submit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item
            name="time"
            label="sumit"
            rules={[{ required: false }]}
            hidden={true}
          >
            <Input placeholder="Submit" autocomplete="off" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {submitType == "insert" ? "Submit" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table
        bordered
        className="tableData"
        dataSource={dataSource}
        columns={columns}
        loading={loading}
        pagination={{ pageSize: 10, total: { totalRecord } }}
      ></Table>
      <Modal
        title={"Add Permission"}
        style={{ top: 20 }}
        visible={visiblePermission}
        onOk={() => closePermission()}
        onCancel={() => closePermission()}
        width={"90vw"}
        maskClosable={false}
        footer={null}
      >
        <Row gutter={24}>
          <Col span={8}>
              <Input placeholder="Permission" id="permissionData" autocomplete="off" />
          </Col>
          <Col span={4}>
          <Button type="primary" onClick={handlePermissionInsert}>
              +Add Permission
            </Button>
          </Col>
          </Row>
        <Table
        bordered
        className ="tableData"
        dataSource={permissionSet}
        columns   ={permissionColumn}
        loading   ={loading}
        pagination={{ pageSize: 5, total: { totalRecord } }}
      ></Table>
      </Modal>
    </>
  );
};
export default Masterprofile;
